export enum Equity {
    No = 'No',
    Yes = 'Yes',
    YesMinority = 'YesMinority',
    YesMajorityMinority = 'YesMajorityMinority',
}